import React from 'react';
import './Services.css';
import Footer from '../Footer';
import { Button } from '../Button';

export default function Services() {
    return (
        <>
        <h1 className='services'>SERVICES</h1>
        <div className='service1'>
            <div className='service1-text-wrapper'>
                <h1 className='service-heading-style'>Mortgages</h1>
                <p className='service-paragraph-style'>
                Buying a home, refinancing, or investing in property doesn't have to be complicated. 
                Our goal is to simplify the process for you by connecting you with lenders that offer 
                competitive rates and flexible terms to suit your financial plans. From guiding you through 
                pre-approval to ensuring a smooth closing, we provide expert support every step of the way. 
                With us managing the details, you can focus on what matters most—finding the perfect property!
                </p>
                <Button className='btns' buttonStyle={'btn--outline'} buttonSize={'btn--large'} path={'/contact'}>
                    Find out how!
                </Button>
            </div>
        </div>
        <div className='service2'>
            <div className='service2-text-wrapper'>
                <h1 className='service-heading-style'>Calculator</h1>
                <p className='service-paragraph-style'>
                    Our mortgage calculator makes it easy to estimate your monthly payments, compare loan options, 
                    and plan your budget with confidence. Simply enter your loan amount, interest rate, and term to get 
                    instant insights into your mortgage costs. Whether you're a first-time buyer or looking to refinance, 
                    this tool helps you make informed decisions about your home financing. 
                    Try it today and take the guesswork out of your mortgage planning!
                </p>
                <Button className='btns' buttonStyle={'btn--outline'} buttonSize={'btn--large'} path={'/calculator'}>
                    Find The Best Rate!
                </Button>
            </div>
        </div>
        <div className='service3'>
            <div className='service3-text-wrapper'>
                <h1 className='service-heading-style'>Online Application</h1>
                <p className='service-paragraph-style'>
                    Our secure online mortgage application makes getting started easier than ever. 
                    Apply from the comfort of your home in just a few minutes, providing the key details needed to 
                    begin your mortgage approval process. With a simple and user-friendly interface, you can quickly 
                    submit your application and get one step closer to your dream home!
                </p>
                <Button className='btns' buttonStyle={'btn--outline'} buttonSize={'btn--large'} path={'/contact'}>
                    Get Started!
                </Button>
            </div>
        </div>
        <Footer />
        </>
    )
}